import gql from 'graphql-tag';

export default gql`
  subscription onUpdateCollection($userid: ID!) {
    onUpdateCollection(userid: $userid) {
      id
    }
  }
`;
